import _isEmpty from "lodash/isEmpty";
import _debounce from "lodash/debounce";
import React, { useCallback, useRef } from 'react';
import analyticsModule from '@nerdwallet/analytics';
import styles from './Table.module.less';
export var TableContainer = function TableContainer(_ref) {
  var analytics = _ref.analytics,
      children = _ref.children,
      impressionId = _ref.impressionId;
  var ref = useRef(); // eslint-disable-next-line react-hooks/exhaustive-deps

  var onScroll = useCallback(_debounce(function () {
    var _ref$current;

    if (ref !== null && ref !== void 0 && (_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.scrollLeft && analytics !== null && analytics !== void 0 && analytics.enabled) {
      var _ref$current2;

      var payload = {
        action: 'browse',
        entity_name: 'table_scroll_h',
        interaction_type: 'swipe',
        scroll_width: ref === null || ref === void 0 ? void 0 : (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.scrollLeft
      };

      if (impressionId) {
        payload.impression_id = impressionId;
      }

      analyticsModule.track('table_horizontal_scrolled', payload);
    }
  }, 250), [ref, analytics, impressionId]);

  if (_isEmpty(children)) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.tableContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.tableBorder,
    onScroll: onScroll,
    ref: ref
  }, children));
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  TableContainer.propTypes = {
    /**
     * The content used by that analytics module
     * and the flag to determine if analytics is sent
     * */
    analytics: PropTypes.shape({
      enabled: PropTypes.bool,
      payload: PropTypes.shape({
        elementName: PropTypes.string
      })
    }),

    /** Children to render within the container */
    children: PropTypes.node,

    /** Used for impression identification */
    impressionId: PropTypes.string
  };
}

TableContainer.defaultProps = {
  analytics: {
    enabled: false
  },
  children: null,
  impressionId: null
};